import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMaterialUIController } from "context";
import { getBronzeData } from "../../helpers/medallion";
import Spinner from "../../components/Spinner/Spinner";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import MDBox from "../../components/MDBox";
import DataTable from "../../components/table/Table";
import Pagination from "../../components/pagination/Pagination";
import DetailsModal from "../../components/modal/DetailsModal";
import { itemsPerPage, itemsTotal } from "../../constants";
import useColumnsPerConnectorConfig from "./BronzeLevelColumns";

function BronzeLevelData({ match }) {
  const connectorType = match?.params?.type;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [sortBy, setSortBy] = useState("timestamp");
  const [sortDir, setSortDir] = useState("desc");
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [offset, setOffset] = useState(1);

  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const columnsConnectorMap = useColumnsPerConnectorConfig(connectorType);

  const [controller] = useMaterialUIController();
  const { startDate, endDate } = controller;

  const fetchData = async (newOffset = offset) => {
    if (!connectorType) return;

    setLoading(true);
    try {
      const response = await getBronzeData(
        connectorType,
        newOffset,
        itemsPerPage,
        sortBy,
        sortDir,
        startDate ?? "",
        endDate ?? ""
      );
      setData(response.data.events);
      setPageCount(Math.ceil((response.data.total || itemsTotal) / itemsPerPage));
      setError(false);
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(0)
    fetchData(1);
  }, [connectorType])

  useEffect(fetchData, [offset, sortBy, sortDir, startDate, endDate]);

  useEffect(() => {
    if (selectedEventId) {
      setIsOpen(true);
      const selectedEventItem = data.find((event) => event.uuid === selectedEventId);
      setSelectedEvent({
        ...selectedEventItem,
        raw_event: undefined,
        raw: JSON.stringify(selectedEventItem.raw_event),
      });
    }
    return null;
  }, [selectedEventId]);

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    const pageItems = selectedPage * itemsPerPage;
    setCurrentPage(selectedPage);
    setOffset(pageItems + 1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DetailsModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        loading={false}
        error={false}
        data={selectedEvent}
        modalTitle="DisregardedEvents"
        showRawData
        size="xl"
        onRowClick={setSelectedEventId}
        showQueryStringParameters
        isDisregardedOnly
      />
      {loading && <Spinner />}
      {!loading && error && <ErrorMessage />}
      {!loading && !error && connectorType && (
        <MDBox>
          <Card>
            <DataTable
              data={data}
              columns={columnsConnectorMap[connectorType]}
              param="uuid"
              sortBy={sortBy}
              sortDir={sortDir}
              setSortBy={setSortBy}
              setSortDir={setSortDir}
              hoverable
              cursorPointer
              onRowClick={setSelectedEventId}
            />
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={pageCount}
              currentPage={currentPage}
            />
          </Card>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default BronzeLevelData;
